<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">郵便番号管理</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="error" dark rounded depressed small @click="dialog = true">削除</v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="start" justify="start">
          <v-col cols="12" class="pa-0">
            <v-alert type="warning">
              「住所の郵便番号（ローマ字・zip形式）」を指定してください
            </v-alert>
            <v-alert type="error">
              firebase database:settings:set defaultWriteSizeLimit unlimited
            </v-alert>
          </v-col>
          <v-col cols="12" class="pa-0" align="end">
            <input @change="select" type="file" name="file" accept="text/csv" ref="file">
            <v-chip @click="onFile()" small color="primary"><v-icon v-if="!file" class="pr-1">mdi-file-document-box-search</v-icon><span>{{ fileName ? fileName : '選択してください' }}</span></v-chip>
            <v-btn v-if="file != null" dark depressed fab x-small @click="onReset()" color="error" class="ml-2"><v-icon >mdi-close</v-icon></v-btn>
            <v-btn rounded depressed small color="error" :disabled="file == null"  class="mx-2" @click.native="uploadDialog = true">
              <span class="text-none">保存</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" align="center" justify="start">
          <v-col cols="1" class="pa-0"></v-col>
          <v-col cols="3" class="pa-0">
            <v-text-field
              v-model="postcode"
              label="Postcode"
              append-outer-icon="search"
              type="text"
              @click:append-outer="search"
            ></v-text-field>
          </v-col>
          <v-col cols="8" class="pa-0"></v-col>
          <v-col cols="1" class="pa-0"></v-col>
          <v-col cols="10" class="pa-0">
            <v-alert
              v-if="result != null && postcode != ''"
              :value="true"
              type="info"
              dismissible
            >
              <v-list-item-content>{{ result.a0 }}</v-list-item-content>
              <v-list-item-content>{{ result.a7 }}</v-list-item-content>
              <v-list-item-content>{{ result.a1 }}</v-list-item-content>
              <v-list-item-content>{{ result.a2 }}</v-list-item-content>
              <v-list-item-content>{{ result.a3 }}</v-list-item-content>
              <v-list-item-content>{{ result.a4 }}</v-list-item-content>
              <v-list-item-content>{{ result.a5 }}</v-list-item-content>
              <v-list-item-content>{{ result.a6 }}</v-list-item-content>
            </v-alert>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='削除'
        message='郵便番号データを全て削除します。よろしいですか?'
        :dialog='dialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='保存'
        message='郵便番号データを保存します。よろしいですか?'
        :dialog='uploadDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
import 'firebase/database'
import * as async from 'async'
import * as Papa from 'papaparse'
export default {
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      dialog: false,
      uploadDialog: false,
      loading: false,
      file: null,
      jsonData: null,
      postcode: '',
      address: '',
      result: null,
      fileName: null
    }
  },
  methods: {
    async select (e) {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(500).then(() => {
        this.fileRead(e)
      })
    },
    onFile () {
      this.$refs.file.click()
    },
    onReset () {
      this.$refs.file.value = null
      this.file = null
      this.fileName = null
    },
    fileRead (e) {
      var vm = this
      vm.file = null
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      this.file = files[0]
      this.fileName = this.file.name
      var reader = new FileReader()
      reader.onerror = function () {
        console.log('error')
      }
      vm.loading = true
      vm.jsonData = []
      reader.onload = function () {
        Papa.parse(files[0], {
          encoding: 'Shift-JIS',
          header: false,
          complete: function (results) {
            for (var i in results.data) {
              var payload = {
                a0: results.data[i][0],
                a1: results.data[i][1],
                a2: results.data[i][2],
                a3: results.data[i][3],
                a4: results.data[i][4],
                a5: results.data[i][5],
                a6: results.data[i][6]
              }
              if (typeof results.data[i][6] !== 'undefined') {
                vm.jsonData.push(payload)
              }
            }
            vm.loading = false
          },
          error () {
            vm.loading = false
          }
        })
      }
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(300).then(() => {
        reader.readAsArrayBuffer(this.file)
      })
    },
    upload () {
      var vm = this
      vm.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(300).then(() => {
        const db = firebase.database()
        async.eachSeries(this.jsonData, function (element, cb) {
          var a7 = (element.a1 + element.a2 + element.a3).replace('　', '').replace('　', '')
          db.ref('postcode/' + element.a0).set({
            a0: element.a0,
            a1: element.a1,
            a2: element.a2,
            a3: element.a3,
            a4: element.a4,
            a5: element.a5,
            a6: element.a6,
            a7: a7
          }, function (error) {
            if (error) {
              console.log(error)
              cb(error)
            } else {
              cb()
            }
          })
        }, function (error) {
          if (error) {
            console.log(error)
          }
          vm.onReset()
          vm.loading = false
        })
      })
    },
    search () {
      var vm = this
      this.loading = true
      var payload = this.postcode
      this.$store.dispatch('postcode/search', payload).then(function (data) {
        if (data) {
          vm.result = data.val()
        }
        vm.loading = false
      })
    },
    onRemove () {
      const db = firebase.database()
      db.ref('postcode/').remove()
      this.dialog = false
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.uploadDialog) {
        this.uploadDialog = false
        if (value) {
          this.upload()
        }
        return
      }
      if (this.dialog) {
        if (value) {
          this.onRemove()
        }
      }
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

input[type="file"]:focus {
  outline: 0 !important;
}

input[type="file"] {
  display: none;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
